import React from 'react'

export const CreativeAssetsIcon = React.forwardRef<SVGSVGElement>((props, ref): React.ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19" viewBox="0 0 19 19" fill="none" {...props} ref={ref}>
      <path
        d="M8.71289 0.0595703C8.96878 -0.0328932 9.25362 -0.0176609 9.5 0.105469L11.8301 1.27051L11.6904 1.69043L10.5537 2.06934C10.2584 2.1678 10.006 2.31275 9.79492 2.48926L9.05273 2.11816L3.23633 5.02637L9.05273 7.93457L11.5176 6.70215L11.6904 6.75977L12.0693 7.89648C12.1459 8.12605 12.2515 8.32913 12.377 8.50781L9.5 9.94727C9.21855 10.0879 8.88692 10.0879 8.60547 9.94727L0.552734 5.9209C0.21407 5.75148 1.9393e-05 5.40505 0 5.02637C1.45399e-05 4.64767 0.21406 4.30125 0.552734 4.13184L8.60547 0.105469L8.71289 0.0595703Z"
        fill="currentColor"
      />
      <path
        d="M1.00024 13.079L9.05288 17.1053L17.1055 13.079"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.00024 9.05273L9.05288 13.0791L17.1055 9.05273"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5745 2.36758L13.9683 1.18627C14.0511 0.937746 14.4027 0.937746 14.4855 1.18627L14.8793 2.36758C15.0692 2.93736 15.5163 3.38447 16.0861 3.5744L17.2674 3.96817C17.5159 4.05101 17.5159 4.40254 17.2674 4.48538L16.0861 4.87915C15.5163 5.06908 15.0692 5.51619 14.8793 6.08597L14.4855 7.26728C14.4027 7.51579 14.0511 7.51579 13.9683 7.26728L13.5745 6.08597C13.3846 5.51619 12.9375 5.06908 12.3677 4.87915L11.1864 4.48538C10.9379 4.40254 10.9379 4.05101 11.1864 3.96817L12.3677 3.5744C12.9375 3.38447 13.3846 2.93736 13.5745 2.36758Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default CreativeAssetsIcon
